<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Dövizli Mizan</v-toolbar-title>
              <v-spacer></v-spacer>

 <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>

            </v-toolbar>
          </v-flex>

          <v-container fluid>

            <v-card color="grey lighten-5" flat>
                            <v-form ref="formtarih" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex xs12 sm6 md2>
                   <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>


                </v-flex>

                <v-flex xs12 sm6 md2>
                            <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                </v-flex>

                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                      color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                      <span>Arama Filtresi Ekle</span>
                    </v-tooltip>
                  </v-layout>
                </v-flex>

                <v-dialog v-model="dialogfiltre" persistent="" max-width="530px">
                  <v-card color="grey lighten-5">
                    <v-card-title>Filtre Seçimi</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>

                      <v-flex pa-1 xs12 sm12 md12>
                        <v-card>
                          <v-card color="grey lighten-5" flat="">
                            <v-card-actions>



                              <v-layout justify-space-between column>
                                <v-autocomplete label="Hesap Kodu" clearable :loading="loading" v-model="Mizan.Cari.Kod"
                                  append-icon="search" :items="hesapkodu" item-text="text" cache-items="" item-value="id"
                                  :search-input.sync="search">
                                </v-autocomplete>
                                <v-select :items="hesapgurubu" hide-details="" v-model="Mizan.HesapGrubu" label="İstenilen Hesap Gurubu"
                                  multiple item-text="Adi" item-value="Kod" max-height="400"></v-select>
                                <v-select :items="hesapgurubu" hide-details="" v-model="Mizan.NoHesapGrubu" label="İstenmeyen Hesap Gurubu"
                                  multiple item-text="Adi" item-value="Kod" max-height="400" persistent-hint></v-select>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-card>
                      </v-flex>
                      <v-flex pa-1 xs12 sm12 md12>
                        <v-layout justify-space-between column>
                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                            </v-card-title>
                          </v-card>
                          <v-radio-group hide-details="" v-model="Mizan.DonemKumulatif" column>
                            <v-radio label="Kümülatif (Verile Bitiş Tarihine Kadar Tüm Kayıtlar.)" value="true">
                            </v-radio>
                            <v-radio label="Dönem (Verilen Tarihler Arası Kayıtlar)" value="false"></v-radio>
                          </v-radio-group>
                          <v-checkbox hide-details="" v-model="Mizan.FaturaTarih" label="Fatura Tarihine Göre Mizan Al"></v-checkbox>
                          <v-checkbox hide-details="" v-model="tumsirketler" label="Tüm Şirketler"></v-checkbox>
                        </v-layout>
                      </v-flex>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </v-layout>
                            </v-form>
            </v-card>
          </v-container>


          <v-container v-if="doviztrue" fluid>
            <v-flex xs12 sm12 md12>
              <v-card flat="" color="#9E9E9E">
                <v-card-title>
                  <span class="subheading white--text font-weight-medium "> Döviz Rapor Özet Sonuçları</span>
                </v-card-title>
              </v-card>

            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>

                </v-card-title>
                <v-data-table :headers="headersdoviz" :rows-per-page-items=[50,100] :loading="progress" :items="dovizList">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.DovizKod }}</td>
                    <td class="text-xs-right">{{ props.item.ToplamAlacak | moneyformat  }}</td>
                    <td class="text-xs-right">{{ props.item.ToplamAlacakBakiye | moneyformat}}</td>
                    <td class="text-xs-right">{{ props.item.ToplamBorc | moneyformat }}</td>
                    <td class="text-xs-right">{{ props.item.ToplamBorcBakiye | moneyformat}}</td>

                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-container>


          <v-container fluid>
            <v-flex xs12 sm12 md12>

              <v-card flat="" color="#9E9E9E">
                <v-card-title>
                  <span class="subheading white--text font-weight-medium "> Döviz Cari Hesap Mizanı</span>
                </v-card-title>
              </v-card>


            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-card>

                <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                  :search="search3">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                    <td class="text-xs-left">{{ props.item.Unvan }}</td>
                    <td class="text-xs-left">{{ props.item.DovizKod}}</td>
                    <td class="text-xs-right">{{ props.item.CariBorc | moneyformat}}</td>
                    <td class="text-xs-right">{{ props.item.CariAlacak | moneyformat}}</td>
                    <td class="text-xs-right">{{ props.item.BorcBakiye | moneyformat }}</td>
                    <td class="text-xs-right">{{ props.item.AlacakBakiye | moneyformat }}</td>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                  </v-alert>
                </v-data-table>
              </v-card>

              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
              </v-snackbar>
            </v-flex>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'

  export default {
    data() {
      return {
        search: '',
        dovizList: [],


        headersdoviz: [{
            text: 'Döviz Kodu',
            value: 'DovizKod'
          },
          {
            text: 'Toplam Alacak',
            value: 'ToplamAlacak',
            align:  'right'

          },
          {
            text: 'Toplam Alacak Bakiye',
            value: 'ToplamAlacakBakiye',
            align:  'right'

          },
          {
            text: 'Toplam Borç',
            value: 'ToplamBorc',
            align:  'right'

          },
          {
            text: 'Toplam Borç Bakiye',
            value: 'ToplamBorcBakiye',
            align:  'right'

          }
        ],




        headers: [{
            text: 'Hesap Kodu',
            value: 'Kod'
          },
          {
            text: 'Hesap Adı',
            value: 'Unvan'
          },
          {
            text: 'Döviz',
            value: 'DovizKod'
          },
          {
            text: 'Cari Borç',
            value: 'CariBorc',
            align:  'right'

          },
          {
            text: 'Cari Alacak',
            value: 'CariAlacak',
            align:  'right'

          },
          {
            text: 'Borç Bakiye',
            value: 'BorcBakiye',
            align:  'right'

          },
          {
            text: 'Alacak Bakiye',
            value: 'AlacakBakiye',
            align:  'right'

          }
        ],
        valid:true,
        Mizan: {
          SirketKodu: '',
          Cari: {
            Kod: '',
          },
          HesapGrubu: '',
          NoHesapGrubu: '',
          DonemKumulatif: '',
          BaslangicTarih: this.date,
          BitisTarih: this.date2,
          FaturaTarih: '',


          Unvan: '',
          DovizKod: '',
          CariBorc: '',
          CariAlacak: '',
          BorcBakiye: '',
          AlacakBakiye: ''
        },
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        progress: false,
        search1: '',
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        doviztrue: false,
        tumsirketler: false,
        tooltip: false,
        el: null,
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeMount: beforeMount,
       components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    }
  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapkodu = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false


  }

  function getList() {

   if (this.$refs.formtarih.validate()) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {

          this.progress = true
          this.load1 = false

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.Mizan.BaslangicTarih = this.date
          this.Mizan.BitisTarih = this.date2
          if (this.tumsirketler === true) {
            this.Mizan.SirketKodu = '0'
          } else {
            this.Mizan.SirketKodu = credentials.SirketKodu
          }

          var params = this.Mizan

          this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrency', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.mizan = false

            if (response.body.DovizList.length > 0) {
              this.doviztrue = true
            } else {
              this.doviztrue = false
            }



            this.dovizList = response.body.DovizList
            this.items = response.body.MizanList
            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.mizan = false
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.mizan = false
              this.progress = false
              this.load1 = true
            }
          })

        } else {
          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
      }

  }


  function getListHtml() {
    this.load1 = false



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.Mizan.BaslangicTarih = this.date
    this.Mizan.BitisTarih = this.date2
    if (this.tumsirketler === true) {
      this.Mizan.SirketKodu = '0'
    } else {
      this.Mizan.SirketKodu = credentials.SirketKodu
    }

    var params = this.Mizan

    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrencyHtmlReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "MizanDoviz.html";
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      }
    })
  }

  function getListExcel() {
    this.load1 = false


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.Mizan.BaslangicTarih = this.date
    this.Mizan.BitisTarih = this.date2
    if (this.tumsirketler === true) {
      this.Mizan.SirketKodu = '0'
    } else {
      this.Mizan.SirketKodu = credentials.SirketKodu
    }

    var params = this.Mizan

    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrencyExcelReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: "arraybuffer"
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "MizanDoviz.xlsx";
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.mizan = false
        this.progress = false
        this.load1 = true
      }
    })
  }


  function beforeMount() {
    this.mizan = false

  }


</script>

<style>
</style>